var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,8L21,7.988C20.998,7.807 20.947,7.637 20.861,7.492C20.819,7.42 20.767,7.353 20.707,7.293L14.707,1.293C14.647,1.233 14.58,1.181 14.508,1.139C14.362,1.053 14.193,1.002 14.012,1L14,1L6,1C4.354,1 3,2.354 3,4L3,20C3,21.646 4.354,23 6,23L18,23C19.646,23 21,21.646 21,20L21,8ZM13,3L6,3C5.451,3 5,3.451 5,4C5,4 5,20 5,20C5,20.549 5.451,21 6,21C6,21 18,21 18,21C18.549,21 19,20.549 19,20L19,9L14,9C13.448,9 13,8.552 13,8L13,3ZM11,14L9,14C8.448,14 8,14.448 8,15C8,15.552 8.448,16 9,16L11,16L11,18C11,18.552 11.448,19 12,19C12.552,19 13,18.552 13,18L13,16L15,16C15.552,16 16,15.552 16,15C16,14.448 15.552,14 15,14L13,14L13,12C13,11.448 12.552,11 12,11C11.448,11 11,11.448 11,12L11,14ZM15,7L17.586,7L15,4.414L15,7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/file-plus.c3f75220.svg";
export { ForwardRef as ReactComponent };